export default {
    LOAD_MY_TASK(state, my_task) {
        state.items = my_task;
    }
}